export const BUTTON_WITH_ARROW_BACKGROUND_TYPE = {
  YELLOW: "yellow",
  GRAY: "gray"
};

// Must stay at or below PlansPage `textSM.lineHeight` (18.9) so the button
// does not grow when the in-button loader is shown next to the label.
export const BUTTON_WITH_ARROW_LOADER_SIZE = 16;
